import { render, staticRenderFns } from "./full-screen-attachment.vue?vue&type=template&id=436687ce&scoped=true&"
import script from "./full-screen-attachment.vue?vue&type=script&lang=js&"
export * from "./full-screen-attachment.vue?vue&type=script&lang=js&"
import style0 from "./full-screen-attachment.vue?vue&type=style&index=0&id=436687ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "436687ce",
  null
  
)

export default component.exports